import { render, staticRenderFns } from "./topicinfo.vue?vue&type=template&id=bc8d46ae&scoped=true"
import script from "./topicinfo.vue?vue&type=script&lang=js"
export * from "./topicinfo.vue?vue&type=script&lang=js"
import style0 from "./topicinfo.vue?vue&type=style&index=0&id=bc8d46ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8d46ae",
  null
  
)

export default component.exports